"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var button_group_1 = require("../../controls/button-group");
wp.customize.controlConstructor['epsilon-button-group'] = wp.customize.Control.extend({
    ready: function () {
        var control = this;
        new button_group_1.EpsilonButtonGroup(control);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/customizer/extenders/controls/button-group.ts
// module id = 11
// module chunks = 0